// 导入React相关依赖
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// 导入样式文件
import './EditTab.less';
// 导入标签页图标资源
import NavSpeech from '@/assets/edit/nav_script.png';
import NavSpeechspeech from '@/assets/edit/nav_script_highlight.png';
import NavSubtitle from '@/assets/edit/nav_captions.png';
import NavSubtitlesubtitle from '@/assets/edit/nav_captions_highlight.png';
import NavBackground from '@/assets/edit/nav_BG.png';
import NavBackgroundbackground from '@/assets/edit/nav_BG_highlight.png';
import NavStyle from '@/assets/edit/nav_style.png';
import NavStylestyle from '@/assets/edit/nav_style_highlight.png';
// 导入编辑上下文
import { EditContext } from '@/context/EditContext';
import { useTranslation } from 'react-i18next';
import LogoImg from '@/assets/edit/logo.png';
// 定义标签页配置数组,包含每个标签页的key、图标、高亮图标和文本
const TAB_CONFIG = [
  {
    key: 'speech', // 脚本标签页
    icon: NavSpeech, // 默认图标
    activeIcon: NavSpeechspeech, // 激活状态图标
    text: 'As_Edit_SpaceVoice334', // 显示文本
  },
  {
    key: 'subtitle', // 字幕标签页
    icon: NavSubtitle,
    activeIcon: NavSubtitlesubtitle,
    text: 'As_Edit_SpaceSubtitle334',
  },
  {
    key: 'subtitleStyle', // 字幕样式标签页
    icon: NavBackground,
    activeIcon: NavBackgroundbackground,
    text: 'As_Edit_Navchoice5',
  },
  {
    key: 'media', // 画面源样式
    icon: NavStyle,
    activeIcon: NavStylestyle,
    text: 'As_Edit_Editchoice4',
  },
];

// 编辑标签页组件
export default function EditTab() {
  const { t } = useTranslation();
  // 从上下文中获取当前激活的标签页和设置激活标签页的方法
  const { activeTab, setActiveTab, mode } = useContext(EditContext);
  const handleActiveTab = (key) => {
    switch (key) {
      case 'speech':
        window.onClickGATrackEvent('leftnav-speech');
        break;
      case 'subtitle':
        window.onClickGATrackEvent('leftnav-subtitles');
        break;
      case 'subtitleStyle':
        // window.onClickGATrackEvent('leftnav-subtitles');
        break;
      case 'media':
        window.onClickGATrackEvent('leftnav-media');
        break;
      default:
        break;
    }
    setActiveTab(key);
  };
  useEffect(() => {
    if (
      mode === 'translation' ||
      mode === 'add_subtitle_and_translation' ||
      mode === 'add_subtitle'
    ) {
      setActiveTab('subtitle');
    }
  }, [mode]);

  const [logoFlag, setLogoFlag] = useState(false);
  const navigate = useNavigate();
  const handleMouseEnter = () => {
    setLogoFlag(true);
  };
  const handleMouseLeave = () => {
    setLogoFlag(false);
  };
  const handleToHome = () => {
    navigate('/home');
  };
  return (
    // 标签页容器
    <div className="edit_tab_box">
      <div className="logo_img_box">
        <div
          className="tooltip tooltip-bottom tooltip-right logo_img_main"
          data-tip={t('As_Edit_NavLogo')}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleToHome}>
          <img src={LogoImg} alt="" className={logoFlag ? 'logo_img' : 'logo_img1'} />
          <img src={LogoImg} alt="" className={logoFlag ? 'logo_img1' : 'logo_img'} />
        </div>
      </div>
      <div className="edit_tab_main">
        {/* 遍历标签页配置数组,渲染每个标签页 */}
        {TAB_CONFIG.map(({ key, icon, activeIcon, text }) =>
          mode !== 'add_subtitle_and_translation' &&
          mode !== 'add_subtitle' &&
          mode !== 'translation' ? (
            <div
              key={key}
              // 根据是否为当前激活标签页添加激活样式类
              className={`edit_tab_item ${activeTab === key ? 'edit_tab_item_active' : ''}`}
              // 点击切换激活的标签页
              onClick={() => handleActiveTab(key)}>
              {/* 根据激活状态显示对应图标 */}
              <img src={activeTab === key ? activeIcon : icon} alt={text} />
              {/* 显示标签页文本 */}
              <div className="text">{t(text)}</div>
            </div>
          ) : (
            key !== 'speech' && (
              <div
                key={key}
                // 根据是否为当前激活标签页添加激活样式类
                className={`edit_tab_item ${activeTab === key ? 'edit_tab_item_active' : ''}`}
                // 点击切换激活的标签页
                onClick={() => handleActiveTab(key)}>
                {/* 根据激活状态显示对应图标 */}
                <img src={activeTab === key ? activeIcon : icon} alt={text} />
                {/* 显示标签页文本 */}
                <div className="text">{t(text)}</div>
              </div>
            )
          ),
        )}
      </div>
    </div>
  );
}
